<div class="card campanha-pipeline-card-info campanha-pipeline-card-info-reprovada">
    <div class="card-header">
        <h6 class="card-title">
            Reprovação
        </h6>
    </div>
    <div class="card-body">
        <ul class="list-group list-group-flush">
            <li class="list-group-item">
                <span class="list-group-item-values">
                    <span class="list-group-item-value">
                        <i class="far fa-calendar-times"></i> {{dataAnalise | date: 'dd/MM/yyyy'}}
                    </span>
                    <span class="list-group-item-value">
                        <sgt-avatar
                          [settings]="{
                            isShowLabelNameLeft: true,
                            fullName: nomeUsuarioAnalise,
                            imageUrl: avatarURLUsuarioAnalise
                          }">
                        </sgt-avatar>
                    </span>
                </span>
            </li>
            <li class="list-group-item">
                <span class="list-group-item-value">
                    {{justificativaAnalise}}
                </span>
            </li>
        </ul>
    </div>
</div>
